var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "accordion", class: _vm.rootClasses }, [
    _c(
      "button",
      {
        staticClass: "u-reset accordion--head",
        attrs: { type: "button" },
        on: {
          click: function($event) {
            $event.preventDefault()
            _vm.onRequestChange(!_vm.state.isActive)
          }
        }
      },
      [_vm._t("head", null, { isActive: _vm.state.isActive })],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "body",
        staticClass: "accordion--body",
        style: [_vm.accordionBodyStyles],
        on: {
          transitionend: function($event) {
            _vm.finishAnimation($event)
          }
        }
      },
      [_vm._t("body")],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0a2b307b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a2b307b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./vehi-industriepfad/assets/src/js/app/framework/components/ui/accordion/index.vue
// module id = 427
// module chunks = 5